import { DiseaseModel } from './../../../models/consultation-process/disease.model';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { Utility } from '../../../common/utility';
@Injectable()
export class PrescribeVaccinationService {
    constructor(public baseService: BaseService) {

    }

    getPrescribeVaccinationList(id) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION, [id]);
        return this.baseService.get(url);
    }

    getCourseList() {
        const url = MasterDataUrl.GET_DEFAULT_COURSE;
        return this.baseService.get(url);
    }

    getDateRangeList() {
        return dateList;
    }

    getDefaultDateList() {
        return defaultDateRange;
    }

    getDiseaseByVaccine(consultationId, vaccineId, diseaseId) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION_BY_VACCINEID, [consultationId, diseaseId, vaccineId]);
        return this.baseService.get(url);
    }

    removePrescribeVaccination(consultationId, patientVaccineId) {
        const url = Utility.stringFormat(ConsultationUrl.REMOVE_PRESCRIBE_VACCINATION, [consultationId, patientVaccineId]);
        return this.baseService.delete(url);
    }

    getNewAddPrescribeVaccinationOfDisease(consultationId, diseaseIds) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION_BY_DISEASEID, [consultationId]);
        return this.baseService.postData(url, diseaseIds);
    }

    updatePrescribeVaccination(consultationId, patientVaccine, isMoveNextStep) {
        let url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION, [consultationId]);
        url += '?isMoveNextStep='+ isMoveNextStep;
        return this.baseService.postData(url, patientVaccine);
    }

    getNoOfAdminister(courseId, vaccineId) {
        const url = Utility.stringFormat(MasterDataUrl.GET_VACCINE_ADMINISTER_COURSE_NUMBER, [vaccineId, courseId]);
        return this.baseService.getData(url);
    }
}

/* const diseases = [
    {
        id: '1',
        name: 'disease 1'
    },
    {
        id: '1',
        name: 'disease 2'
    }
]; */

const defaultDateRange: Array<any> = [
    {
        value: 0,
        name: 'Today'
    },
    {
        value: 7,
        name: '7 days'
    },
    {
        value: 14,
        name: '14 days'
    },
    {
        value: 30,
        name: '30 days'
    },
    {
        value: 180,
        name: '180 days'
    },
    {
        value: 365,
        name: '365 days'
    }
];

const dateList = [
    { date: null, isDisable: false, visitDate: null},
    { date: null, isDisable: false, visitDate: null },
    { date: null, isDisable: false, visitDate: null },
    { date: null, isDisable: false, visitDate: null },
    { date: null, isDisable: false, visitDate: null},
    { date: null, isDisable: false, visitDate: null}
];

/* const courses = [
    {
        id: 0,
        name: 'D'
    },
    {
        id: 1,
        name: 'B',
    },
    {
        id: 2,
        name: 'P'
    }
]; */






// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/prescribe-vaccination/prescribe-vaccination.service.ts